<div>
    <ngx-json-viewer [json]="jsonToDisplay" [expanded]="false" class="json"></ngx-json-viewer>
</div>
